module.exports = __webpack_public_path__ + "img/language-1.cb61a517.svg";